// Module
var code = "<template>\n\t<autocomplete datasource=\"quick-search\"\n\t\tsize=\"large\"\n\t\tplaceholder-resource=\"Placeholder_Search\"\n\t\tname-key=\"name\"\n\t\tspecifier-key=\"specifier\"\n\t\turl-key=\"url\"\n\t\titem-selected.call=\"navigateToItem(item)\"\n\t></autocomplete>\n</template>\n";
// Exports
export default code;